import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-new-project-header',
  templateUrl: './new-project-header.component.html',
  styleUrls: ['./new-project-header.component.css'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewProjectHeaderComponent {
  @Input() tituloControl!: FormControl | null;
  @Input() addressUser: string | null = null;
  @Input() addressUserTruncate: string | null = null;
  @Input() hideBlockchain: boolean = true;
  @Input() isEditMode: boolean = false;
  @Output() connectWallet = new EventEmitter<void>();
  @Output() openSettings = new EventEmitter<void>();

  constructor() {}

  connect() {
    this.connectWallet.emit();
  }

  onOpenSettings() {
    this.openSettings.emit();
  }
}
